<template>
	<div class="container">
		<div class="qrcode">
			<el-image :src="qrcode"></el-image>
		</div>
		<!-- <p>当前版本:</p> -->
		
	</div>
</template>

<script>
	export default {
		name: 'buy_detail',
		components: {
			// sidebar,
		},
		data: () => {
			return {
				qrcode:null,
				// newsList:[]
			};
		},
		created() {},
		methods:{
			
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.container{
		display: flex;
		flex-wrap: wrap;
		padding: 50px;
		.qrcode{
			width: 150px;
			height: 150px;
			.el-image{
				
			}
		}
		.el-btn{
			
		}
	}
</style>
